
<button class="lang-btn" [matMenuTriggerFor]="menu">
  {{ currentLang }}
  <img
    src="https://media.umangapp.in/cdn/landing/theme/icons/arrow-down-white.svg"
    alt="arrow-down"
    width="12"
    height="8"
    loading="lazy"
    fetchpriority="high"
    
  />
</button>
<mat-menu #menu="matMenu">
  <ng-container *ngFor="let config of languageConfig">
    <button
      *ngIf="config.isActive"
      class="lang-btn-item text-start"
      (click)="
        onLangChange({
          langCode: config.langCode,
          translation: config.translation,
          langName: config.langName
        })
      "
    >
      {{ config.translation }}
      <ng-container *ngIf="config.langCode != 'en'"
        >- {{ config.langName }}</ng-container
      >
    </button>
  </ng-container>
</mat-menu>
